export class RequestStatuses
{
    createdAt: string;
    modifiedAt: string;
    favorites: string[];
    read: string[];
    id: string;
}
